import React, { FC, SetStateAction, Dispatch, useState } from 'react';
import Select from 'react-select';
import { DropdownIndicator, generateSelectStyles } from '../../../common/generateSelectStyling';
import BananatagButton from '../../../componentLibrary/BananatagButton';
import LANGUAGES from '../../../constants/languages';
import { TLanguageCode, TRenderLoadingOption } from '../../../types/thirdPartyContent';
import * as Styled from './styles';

interface IProps {
    setRenderOption: Dispatch<SetStateAction<TRenderLoadingOption>>;
    setCurrentLanguage: Dispatch<SetStateAction<string>>;
    languages: TLanguageCode[];
    defaultLanguage: TLanguageCode;
}

const Preferences: FC<IProps> = ({ setRenderOption, languages, defaultLanguage, setCurrentLanguage }) => {
    const languageOptions = languages.map((language) => {
        const label = LANGUAGES[language]
            ? `${LANGUAGES[language].local} - ${LANGUAGES[language].english}`
            : 'Unavailable';
        return {
            value: language,
            label,
        };
    });
    const defaultLanguageOption = languageOptions.find((option) => {
        const storedSelectedLanguage = localStorage.getItem('sb-selected-language');
        const comparingLanguage = storedSelectedLanguage || defaultLanguage;
        return option.value === comparingLanguage;
    });
    const [selectedLanguage, setSelectedLanguage] = useState<TLanguageCode>(
        defaultLanguageOption?.value || languages[0]
    );

    const handleChange = (option: any) => {
        setSelectedLanguage(option.value);
    };

    const handleCancel = () => {
        setRenderOption('posts');
    };

    const handleSave = () => {
        setCurrentLanguage(selectedLanguage);
        localStorage.setItem('sb-selected-language', selectedLanguage);
        setRenderOption('posts');
    };

    return (
        <div>
            <Styled.Text align="left">Set your preferences for the News list.</Styled.Text>
            <Styled.TitleText align="left">LANGUAGE</Styled.TitleText>
            <Select
                components={{ DropdownIndicator }}
                onChange={handleChange}
                options={languageOptions}
                styles={generateSelectStyles({})}
                defaultValue={defaultLanguageOption}
            />
            <Styled.Notifier>
                Note: If a post wasn’t translated in the selected language, the default language will display instead.
            </Styled.Notifier>
            <Styled.PreferencesActionButtonsWrapper>
                <BananatagButton
                    onClick={handleCancel}
                    size="medium"
                    text="cancel"
                    styling={{ width: 87 }}
                    type="outline"
                />
                <BananatagButton
                    onClick={handleSave}
                    size="medium"
                    text="save"
                    styling={{ width: 87, justifyContent: 'center' }}
                />
            </Styled.PreferencesActionButtonsWrapper>
        </div>
    );
};

export default Preferences;
